module.exports = __webpack_public_path__ + "img/search-header-nav-below-mazda.2acec4a9.png";